module.exports = __webpack_public_path__ + "img/image-thumb-18.a8e7d9be.webp";